import React from 'react'
import SingleIconTileText from './SingleIconTile'
import { styled } from '@mui/material'
import { BaseComponentProps, ElementContainer } from './Ui'
import { space } from '@zuto/theme/src/zuto/core'

interface IconTileGridFourProps extends BaseComponentProps {
  tile1: {
    icon: string
    iconAlt: string
    headingText: string
    bodyText: string
  }
  tile2: {
    icon: string
    iconAlt: string
    headingText: string
    bodyText: string
  }
  tile3: {
    icon: string
    iconAlt: string
    headingText: string
    bodyText: string
  }
  tile4: {
    icon: string
    iconAlt: string
    headingText: string
    bodyText: string
  }
}

const FourTileWrapper = styled('div')<BaseComponentProps>(
  ({ theme, spacingBottomDesktop, spacingBottomMobile }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    marginBottom: spacingBottomMobile,
    [theme.breakpoints.up('md')]: {
      marginBottom: spacingBottomDesktop
    },
    '& .icon-tile': {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: '30px',
      boxSizing: 'border-box',
      '&:last-child': {
        marginBottom: 0
      },
      [theme.breakpoints.up('sm')]: {
        flexDirection: 'column',
        width: 'calc(50% - 16px)',
        '&:nth-of-type(odd)': {
          marginRight: '16px'
        }
      },
      [theme.breakpoints.up('lg')]: {
        marginBottom: 0,
        width: 'calc(25% - 18px)',
        marginRight: '24px',
        '&:nth-of-type(odd)': {
          marginRight: '24px'
        },
        ':nth-of-type(4n)': {
          marginRight: 0
        }
      }
    },
    '& .floating-card-icon': {
      marginRight: `${space[7]}px`
    }
  })
)

const IconTileGridFour: React.FC<IconTileGridFourProps> = ({
  tile1,
  tile2,
  tile3,
  tile4,
  spacingBottomDesktop,
  spacingBottomMobile
}) => {
  const tiles = [tile1, tile2, tile3, tile4]
  return (
    <ElementContainer>
      <FourTileWrapper
        spacingBottomDesktop={spacingBottomDesktop}
        spacingBottomMobile={spacingBottomMobile}
      >
        {tiles.map((tile, index) => (
          <div className="icon-tile" key={index}>
            <SingleIconTileText {...tile} />
          </div>
        ))}
      </FourTileWrapper>
    </ElementContainer>
  )
}

export default IconTileGridFour
